import { sv } from "@dhx/ts-common/dom";
import { calcPointRef } from "../helpers/common";
import { ISeriaConfig, PointData, PointType, SvgElement } from "../types";
import ScaleSeria from "./ScaleSeria";

export default class Area extends ScaleSeria {
	paint(width: number, height: number, prev?:PointData[]): SvgElement {
		super.paint(width, height);

		const svg = [];
		this._form(width, height, svg, prev);
		this._markers(svg);

		return sv("g", {class: "seria", _key: this.id}, svg);
	}
	paintformAndMarkers(width: number, height: number, prev?:PointData[]): [SvgElement, SvgElement] {
		super.paint(width, height);

		const svg = [];
		const markers = [];
		this._form(width, height, svg, prev);
		this._markers(markers);

		return [
			sv("g", {class: "seria", _key: this.id}, svg),
			sv("g", {class: "seria_markers", _key: this.id + "_markers"}, markers)
		];
	}
	protected _markers(svg:any[]){
		if (this.config.pointType) {
			const color = this.config.pointColor || this.config.color;
			const point = this._getPointType(this.config.pointType, color, false);
			svg.push(...this._points.map(p => point(p[0], p[1], calcPointRef(p[2], this.id))));
		}
	}
	protected _form(width: number, height: number, svg:any[], prev: PointData[]): object {
		const css = `chart ${this.config.type} ${this.config.css || ""} ${this.config.dashed ? "dash-line" : ""}`;
		const { id, fill, alpha, color, strokeWidth } = this.config;
		const points = this._points;

		const last = points[points.length - 1];
		let d = "";
		if (prev) {
			// bottom line in stacked area
			for (let i=prev.length-1; i>=0; i--){
				const item = prev[i];
				d += (i === points.length - 1 ? `M${item[0]} ${item[1]} ` : `L${item[0]} ${item[1]} `);
			}
			// top line in stacked area
			d += points.map((item, index) => (!index ? `V ${item[1]}` : `L ${item[0]} ${item[1]}`)).join(" ") +`Z`;
		} else {
			d += points.map((item, index) => (index ? `L${item[0]} ${item[1]}` : `M0 ${height} L0 ${item[1]} L${item[0]} ${item[1]}`)).join(" ") +`L${width} ${last[1]} V ${height}`;
		}

		if (strokeWidth) {
			const len = points.length - 1;
			const strokePadding = index => index === len ? -.5 : (index ? 0 : .5);
			const line = points.map((item, index) => (index ? "L" : "M") + `${item[0] + strokePadding(index)} ${item[1]}`).join(" ");
			const linePath = sv("path", {
				"d": line,
				"stroke-width": strokeWidth,
				"stroke": color,
				"fill": "none",
				"class": css
			});
			svg.push(linePath);
		}

		const path = sv("path", {
			"id": "seria" + id,
			d,
			"class": css,
			fill,
			"fill-opacity": alpha,
			"stroke": "none"
		});
		svg.push(path);

		return svg;
	}
	protected _setDefaults(config: ISeriaConfig) {
		const defaults = {
			alpha: 0.3,
			strokeWidth:2,
			fill: config.color || "#5E83BA",
			color: "#5E83BA",
			active: true,
			tooltip: true,
			pointType: PointType.empty
		};
		this.config = {...defaults, ...config};
		const showTooltip = this.config.tooltip;
		const point = this.config.pointType;
		const color = this.config.pointColor || this.config.color;

		if (point) {
			this._drawPointType = this._getPointType(point, color, showTooltip);
		}
	}
}